<div class="text-center form-field">
  <a [routerLink]="" (click)="clickPressed()" class="text-nowrap link cursor-pointer" [class.disabled]="disabled">{{label}}</a>
  <p *ngIf="help" class="form-help mb-0">{{help}}</p>
</div>
